import React, {Fragment} from 'react';
import Typography from '@mui/material/Typography/index.js';

const NotFound = () => (
  <Fragment>
    <Typography>Not found</Typography>
  </Fragment>
);

export default NotFound;
